export default "__VITE_ASSET__02735904__"